import axios from 'axios'
import config from './config'

export default axios.create({
  baseURL: config.API_URL,
  headers: {
    api_key: '18DE5F86-BBB2-4120-85E6-D47227EB26D4',
  },
})
